import {
  BriefcaseBusiness,
  Shield,
  type LucideIcon,
} from "lucide-react";

export type CompanyLogoAsset = {
  src: string;
  variant: "symbol" | "wordmark";
};

export const companyLogoAssets: Record<string, CompanyLogoAsset> = {
  "cloudflare-cybersecurity-agent-platform": {
    src: "/company-logos/cloudflare.svg",
    variant: "wordmark",
  },
  "cloudflare-ddos-protection": {
    src: "/company-logos/cloudflare.svg",
    variant: "wordmark",
  },
  "imperva-incapsula": {
    src: "/company-logos/imperva.svg",
    variant: "wordmark",
  },
  radware: {
    src: "/company-logos/radware.jpg",
    variant: "wordmark",
  },
  "rollout-io": {
    src: "/company-logos/cloudbees.svg",
    variant: "wordmark",
  },
  "n-trig": {
    src: "/company-logos/microsoft.svg",
    variant: "symbol",
  },
  "check-point-sales-operations": {
    src: "/company-logos/check-point.svg",
    variant: "wordmark",
  },
};

const companyLogoIcons: Record<string, LucideIcon> = {
  "independent-startup-advisory": BriefcaseBusiness,
  "elite-military-intelligence-unit": Shield,
};

type CompanyLogoProps = {
  companyId: string;
};

/**
 * The Experience page's company marks live in this one registry. Brand assets
 * identify prior employers; neutral icons remain for non-company entries.
 */
export function CompanyLogo({ companyId }: CompanyLogoProps) {
  const asset = companyLogoAssets[companyId];
  const Icon = companyLogoIcons[companyId] ?? BriefcaseBusiness;

  if (asset) {
    return (
      <span
        className={`company-logo company-logo--asset company-logo--${asset.variant} company-logo--${companyId}`}
        aria-hidden="true"
      >
        <img src={asset.src} alt="" decoding="async" />
      </span>
    );
  }

  return (
    <span className={`company-logo company-logo--${companyId}`} aria-hidden="true">
      <Icon strokeWidth={1.8} />
    </span>
  );
}
